import * as CONSTANTS from "../../Constants/DispctaherActionTypeNamesConstant";
import HttpApiUtil from "../../ApiUtils/HttpApiUtil";
import MERCHANT_CODE from "../../utils/data/merchant_code.json";
import { data } from "jquery";

const ObjHttpApiUtil = new HttpApiUtil();
export const FETCHING_MERCHANT_PAYMENT_DATA_BEGINS = () => ({
  type: CONSTANTS.FETCHING_MERCHANT_PAYMENT_DATA_BEGINS
});

export const FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS = (data, token) => ({
  type: CONSTANTS.FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS,
  merchantPaymentData: { data, token }
});

export const FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS = (data) => ({
  type: CONSTANTS.FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS,
  isIRCTC: data
});

export const FETCHING_MERCHANT_PAYMENT_DATA_FAILURE = error => ({
  type: CONSTANTS.FETCHING_MERCHANT_PAYMENT_DATA_FAILURE,
  error: { error }
});

export function fetchMerchantPayMentDataFromAPI(token) {
  return dispatch => {
    dispatch(FETCHING_MERCHANT_PAYMENT_DATA_BEGINS());
    return ObjHttpApiUtil.FetchMerchantPaymentData(token)
      .then(json => {
        dispatch(FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS(json.data.data, token));

       if(process.env.REACT_APP_MERCHANT_CODE == json.data.data.merchant_data.merchant_id) {
        dispatch(FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS(true));
       } else {
        dispatch(FETCHING_MERCHANT_PAYMENT_IRCTC_DATA_SUCCESS(false));
       }
       
        return json.data.data;
        // return GetMerchantPaymentData("harsh")
        // alert(JSON.stringify(json.data.data));
        // alert(JSON.stringify(json));
        // dispatch(FETCHING_MERCHANT_PAYMENT_DATA_SUCCESS(json.data.data, token));
        //alert(JSON.stringify(json.data.data));
        //return json.data.data;
      })
      .catch(error => {
        //alert("ondis:" + error);
        dispatch(FETCHING_MERCHANT_PAYMENT_DATA_FAILURE(error));
      });
  };
}
function GetMerchantPaymentData(token) {
  return new Promise(resolve => {
    // Resolve after a timeout so we can see the loading indicator
    setTimeout(
      () =>
        resolve({
          "data": {
              "merchant_data": {
                  "merchant_id": 119815,
                  "merchant_access_code": "0b8453fc-d7a2-4770-91cf-e2e01e6f65dd",
                  "merchant_return_url": "https://test.pinepg.in/EIPS/EipsProcessRequestResponsePage",
                  "unique_merchant_txn_id": "210723105436097PL394490",
                  "MerchantReturnUrlId": 0,
                  "arrProgramType": [
                      105,
                      106,
                      110,
                      109,
                      108,
                      101,
                      103,
                      112,
                      112
                  ],
                  "EMIModelTypeId": 2,
                  "IsDynamicRoutingEnabled": false,
                  "IsSaveCardEnabled": false,
                  "merchant_logo": null,
                  "is_surcharge_fee_enabled": false,
                  "is_not_on_sell_rate": false
              },
              "customer_data": {
                  "mobile_no": "7773082288",
                  "email_id": null,
                  "first_name": null,
                  "last_name": null,
                  "customer_id": "358984",
                  "billing_data": {
                      "address1": null,
                      "address2": null,
                      "address3": null,
                      "pincode": null,
                      "city": null,
                      "state": null,
                      "country": null
                  },
                  "shipping_data": {
                      "first_name": null,
                      "last_name": null,
                      "mobile_no": null,
                      "address1": null,
                      "address2": null,
                      "address3": null,
                      "pincode": null,
                      "city": null,
                      "state": null,
                      "country": null
                  }
              },
              "payment_data": {
                  "amount_in_paisa": 1350000,
                  "final_convenience_fees_amt_in_paise": 0
              },
              "card_data": {
                  "card_number": null,
                  "cvv": null,
                  "card_holder_name": null,
                  "card_expiry_year": null,
                  "card_expiry_month": null,
                  "is_card_to_be_saved": false,
                  "isLoungeTxn": false,
                  "decryptedCardModel": null,
                  "cardHash1": null,
                  "cardHash2": null,
                  "saltedCardHash1": null,
                  "saltedCardHash2": null,
                  "seededCardHash": null,
                  "last4DigitCard": null,
                  "isTokenTxn": false,
                  "par": null,
                  "isVelocityCheckOnPar": false,
                  "isPluralTxn": false
              },
              "emi_data": {
                  "tenure_id": 0,
                  "offer_scheme": null,
                  "loan_amount": 0,
                  "auth_amount": 0,
                  "monthly_installment": 0,
                  "bank_interest_rate": 0,
                  "interest_pay_to_bank": 0,
                  "total_offerred_discount_cashback_amount": 0
              },
              "txn_data": {
                  "navigation_mode": 2,
                  "payment_mode": "14",
                  "transaction_type": 1,
                  "time_stamp": 0,
                  "pine_pg_txn_id": 7779759,
                  "PaymentModeList": [
                      14
                  ],
                  "SelectedPaymentModeId": 0,
                  "IsInsantDiscountApplied": false,
                  "isNonEMISaveCardTxn": false,
                  "isEmiSavedCardTxn": false,
                  "IssuerIDForAddOnSaleTxn": 0,
                  "llPaymentRequestId": 3914763,
                  "bIsEPOSTxn": true,
                  "isSubscriptionTxn": false,
                  "llSavedCardId": 0,
                  "imeiNoEpos": null,
                  "ProgramTypeEpos": null,
                  "isRequestFromMobile": false,
                  "selectedAcquirerId": 0,
                  "isPreBookedTxn": false,
                  "additionalIMEIData": null,
                  "additionalIMEIDataBase64JsonString": null,
                  "isPluralTxn": false,
                  "isBankEMITxn": false,
                  "isBrandEMITxn": false,
                  "isBrandSubventionDiscountEMITxn": false
              },
              "wallet_data": null,
              "netbanking_data": null,
              "tpv_data": null,
              "udf_data": {
                  "udf_field_1": "",
                  "udf_field_2": "",
                  "udf_field_3": "",
                  "udf_field_4": "",
                  "udf_field_5": ""
              },
              "additional_data": null,
              "BnplData": null,
              "bnpl_data": null,
              "si_data": null,
              "api_source": "v1",
              "acquirerCommData": null,
              "TxnProcessingoptionalParamteres": {
                  "nv": null,
                  "FormCollection": null,
                  "lsProgramTypeApplicables": null,
                  "objMerchantResponseClass": null,
                  "objMerchantSpecificData": null,
                  "objMerchantDataSpecficDataV2": null
              },
              "ParentTxnDetailData": null,
              "upi_data": null,
              "nbfc_data": null,
              "product_details": [
                  {
                      "schemes": [],
                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                      "product_amount": 1350000,
                      "subvention_cashback_discount": 0,
                      "product_discount": 0,
                      "subvention_cashback_discount_percentage": 0,
                      "product_discount_percentage": 0,
                      "bank_interest_rate_percentage": 0,
                      "bank_interest_rate": 0
                  }
              ],
              "payment_mode_data": [
                  {
                      "payment_mode_id": 4,
                      "data": {
                          "special_offers_full_payment_with_cashback": null,
                          "emi_special_offers": null,
                          "emi_model_type": 2,
                          "emi_info": [
                              {
                                  "emi_category": 3,
                                  "emi_category_data": [
                                      {
                                          "card_category": 2,
                                          "issuers": [
                                              {
                                                  "issuer_id": 239,
                                                  "issuer_name": "Axis Debit",
                                                  "is_debit_emi_issuer": true,
                                                  "penny_amount": "1.00",
                                                  "tenures": [
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 31617,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49948,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49948,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "3",
                                                          "tenure_in_month": "3",
                                                          "monthly_installment": 460539,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 31617,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      },
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 55650,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49948,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49948,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "6",
                                                          "tenure_in_month": "6",
                                                          "monthly_installment": 234275,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 55650,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      }
                                                  ],
                                                  "terms_and_conditions": "By placing the order, you have read and agree to : terms & conditions"
                                              },
                                              {
                                                  "issuer_id": 233,
                                                  "issuer_name": "HDFC Bank Debit Card",
                                                  "is_debit_emi_issuer": true,
                                                  "penny_amount": "0.00",
                                                  "tenures": [
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 160000,
                                                                      "bank_interest_rate": 36156,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49899,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49899,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "3",
                                                          "tenure_in_month": "3",
                                                          "monthly_installment": 462052,
                                                          "bank_interest_rate": 160000,
                                                          "interest_pay_to_bank": 36156,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      }
                                                  ],
                                                  "terms_and_conditions": "Note: Convenience fee of Rs.199 +GST applicable for EMI transaction for HDFC bank cards. Additional charges are as applicable: Late payment charges: Rs 550+GST; Auto Debit return charges: 2%+GST on EMI amount, Min of Rs. 550; Pre-closure charges: 3%+GST. GST-18% as per Govt. instructions."
                                              },
                                              {
                                                  "issuer_id": 234,
                                                  "issuer_name": "ICICI Debit",
                                                  "is_debit_emi_issuer": true,
                                                  "penny_amount": "1.00",
                                                  "tenures": [
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 31617,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49949,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49949,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "3",
                                                          "tenure_in_month": "3",
                                                          "monthly_installment": 460539,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 31617,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      },
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 55650,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49949,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49949,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "6",
                                                          "tenure_in_month": "6",
                                                          "monthly_installment": 234275,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 55650,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      },
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 79956,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49949,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49949,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "9",
                                                          "tenure_in_month": "9",
                                                          "monthly_installment": 158884,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 79956,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      }
                                                  ],
                                                  "terms_and_conditions": ""
                                              },
                                              {
                                                  "issuer_id": 237,
                                                  "issuer_name": "Kotak Debit",
                                                  "is_debit_emi_issuer": true,
                                                  "penny_amount": "1.00",
                                                  "tenures": [
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 31617,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49947,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49947,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "3",
                                                          "tenure_in_month": "3",
                                                          "monthly_installment": 460539,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 31617,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      },
                                                      {
                                                          "offer_scheme": {
                                                              "product_details": [
                                                                  {
                                                                      "schemes": [],
                                                                      "product_code": "TEST_PRODUCT_MERCHANT_PRODUCT_CODE",
                                                                      "product_amount": 1350000,
                                                                      "subvention_cashback_discount": 0,
                                                                      "product_discount": 0,
                                                                      "subvention_cashback_discount_percentage": 0,
                                                                      "product_discount_percentage": 0,
                                                                      "subvention_type": 3,
                                                                      "special_offer_cashback": "",
                                                                      "bank_interest_rate_percentage": 140000,
                                                                      "bank_interest_rate": 55650,
                                                                      "product_display_name": "NO_PRODUCT_DISPLAY_NAME"
                                                                  }
                                                              ],
                                                              "emi_scheme": {
                                                                  "scheme_id": 49947,
                                                                  "program_type": 105,
                                                                  "is_scheme_valid": true
                                                              }
                                                          },
                                                          "applicable_scheme": {
                                                              "scheme_id": 49947,
                                                              "program_type": 105,
                                                              "is_scheme_valid": true
                                                          },
                                                          "tenure_id": "6",
                                                          "tenure_in_month": "6",
                                                          "monthly_installment": 234275,
                                                          "bank_interest_rate": 140000,
                                                          "interest_pay_to_bank": 55650,
                                                          "total_offerred_discount_cashback_amount": 0,
                                                          "loan_amount": 1350000,
                                                          "auth_amount": 1350000
                                                      }
                                                  ],
                                                  "terms_and_conditions": "By placing the order, you have read and agree to : terms & conditions"
                                              }
                                          ]
                                      }
                                  ]
                              }
                          ],
                          "EncryptionTerminonlogy": 1,
                          "RandomNumber": "8363548738175471"
                      }
                  }
              ],
              "subscription_data": null,
              "sourceIpAddress": null,
              "tokenize_card_data": null,
              "card_meta_data": null,
              "cardless_data": null,
              "isTokenizePayment": false,
              "isPluralTxn": false,
              "acquirerDetails": null,
              "acsResponseResult": null,
              "CybsDDCRefId": "",
              "CybsTokenizedURLToken": null,
              "CybsFrictionlessPaymentId": null,
              "CybsEMIModel": null,
              "customer_saved_details": null,
              "convenience_fee": null,
              "isPosToEdgeTxn": "0",
              "isReferenceNo": ""
          },
          "response_code": 1,
          "response_message": "SUCCESS"
      }),
      1000
    );
  });
}
